// extracted by mini-css-extract-plugin
module.exports = {"qrCode":"QRCode_qrCode__2nNGY"};